module.exports = __webpack_public_path__ + "rw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/rw.svg
// module id = 1040
// module chunks = 0